import { useUserData } from '../contexts/UserDataContext';

export function OpenOrdersTab() {
  const { openOrders, isConnected, isInitialLoad } = useUserData();

  const showEmptyState = !isConnected || (!isInitialLoad && openOrders.length === 0);
  const emptyMessage = !isConnected
    ? 'Connect wallet to view open orders'
    : 'No open orders';

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}/${day}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="h-full bg-[#0e0f10]">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#1a1d20]">
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Time
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Type
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Coin
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Direction
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Size
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Filled Size
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Order Value
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Price
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Reduce Only
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Status
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Order ID
            </th>
          </tr>
        </thead>
        <tbody>
          {showEmptyState ? (
            <tr>
              <td colSpan={11} className="px-3 py-8 text-center text-[#6c7884] text-[13px]">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            openOrders.map((order, idx) => {
            const isBuy = order.side === 'B';
            const size = parseFloat(order.sz);
            const price = parseFloat(order.limitPx);
            const orderValue = size * price;

            return (
              <tr key={`${order.oid}-${idx}`} className="hover:bg-[#13141a] transition-colors">
                {/* Time */}
                <td className="px-3 py-3 text-left text-[#6c7884] text-[12px]">
                  {formatTime(order.timestamp)}
                </td>

                {/* Type */}
                <td className="px-3 py-3 text-left text-white text-[12px]">
                  Limit
                </td>

                {/* Coin */}
                <td className="px-3 py-3 text-left text-white font-medium text-[12px]">
                  {order.coin}
                </td>

                {/* Direction */}
                <td className="px-3 py-3 text-left">
                  <span className={`text-[12px] font-medium ${
                    isBuy ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                  }`}>
                    {isBuy ? 'Long' : 'Short'}
                  </span>
                </td>

                {/* Size */}
                <td className="px-3 py-3 text-left text-white text-[12px]">
                  {size.toFixed(4)}
                </td>

                {/* Filled Size */}
                <td className="px-3 py-3 text-left text-[#6c7884] text-[12px]">
                  0
                </td>

                {/* Order Value */}
                <td className="px-3 py-3 text-left text-white text-[12px]">
                  ${orderValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>

                {/* Price */}
                <td className="px-3 py-3 text-left text-white text-[12px]">
                  {price.toFixed(2)}
                </td>

                {/* Reduce Only */}
                <td className="px-3 py-3 text-left text-[#6c7884] text-[12px]">
                  --
                </td>

                {/* Status */}
                <td className="px-3 py-3 text-left text-[#6c7884] text-[12px]">
                  Open
                </td>

                {/* Order ID */}
                <td className="px-3 py-3 text-left text-[#6c7884] text-[12px]">
                  {order.oid}
                </td>
              </tr>
            );
          })
          )}
        </tbody>
      </table>
    </div>
  );
}
